<template>
  <div>
    <div
      id="static-backdrop-modal-preview-volunteer"
      class="modal grid justify-center content-center"
      data-backdrop="static"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content bg-theme-25 px-2">
          <div class="modal-header">
            <h4 class="font-medium text-base mr-auto font-bold">
              อพม.
            </h4>
          </div>
          <div class="modal-body grid grid-cols-12 pb-0">
            <div class="md:col-span-12 xs:col-span-12">
              <label class="form-label text-theme-98">
                อพม.<span class="text-theme-5">*</span>
              </label>
            </div>
            <div class="md:col-span-12 xs:col-span-12">
              <v-select
                class="selecthh"
                data-test="dropdown-volunteer"
                id="dropdown-volunteer"
                v-model="state.staffSelected"
                placeholder="กรุณาเลือก อพม."
                :options="staffArr"
                :clearable="false"
                :class="{ errorselect: v$.staffSelected.$errors.length }">
                 <template #selected-option="{ title ,name ,surname }">
                  <div style="display: flex; align-items: baseline">
                    <span>{{ title }} {{ name }} {{ surname }}</span>
                  </div>
                </template>
                  <template #option="{ title ,name ,surname }">
                    <h3 style="margin: 0">{{ title }} {{ name }} {{ surname }}</h3>
                  </template>
                  <template #no-options="{}">
                    ไม่พบข้อมูล
                  </template>
                  <template #open-indicator="{ attributes }">
                    <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                  </template>
                </v-select>
              <div
                class="input-errors"
                v-for="error of v$.staffSelected.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button
              type="button"
              class="btn btn-primary w-15 font-medium"
              data-test="submit-staff-button"
              @click="submitForm"
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import { ref, reactive, watch, onMounted } from "vue";
import { required, helpers, minLength, maxLength } from "@vuelidate/validators";
import axios from "axios";
import store from "@/store";
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  }
});

const staffArr = ref([]);
const state = reactive({
  staffSelected: null,
});
const rules = {
  staffSelected: {
    required: helpers.withMessage("กรุณาเลือก อพม.", required),
  },
};
const v$ = useVuelidate(rules, state);

const normalizerVolunteer = (node) => {
  return {
    id: node._id,
    label: node.title + node.name + " " + node.surname,
  };
};
const submitForm = async () => {
  const isFormCorrect = await v$.value.$validate();
  if (isFormCorrect) {
    store.dispatch("householdFilter/setVolunteer", state.staffSelected);
    store.dispatch("familyFilter/setVolunteer", state.staffSelected);
    store.dispatch("memberFilter/setVolunteer", state.staffSelected);
    localStorage.setItem("volunteerData", JSON.stringify(state.staffSelected));
    swalCustom.fire({
      text:"สำเร็จ",
      icon: 'success',
      timer: 3000,
      confirmButtonText: "ปิด",
    }).then((result) => {
      closeModal();
    });
  }
};
const clearValue = () => {
  state.staffSelected = null;
};
const closeModal = async () => {
  await clearValue();
  v$.value.$reset();
  cash("#static-backdrop-modal-preview-volunteer").modal("hide");
};

const getDatatable = async () => {
  const url = `${process.env.VUE_APP_BASE_API}volunteer/getVolunteer`;
  const res = await axios.post(url, {
    uid: store.getters["userAuth/getUsername"],
  });

  if (res.status === 200) {
    staffArr.value = res.data;    
  }
};

onMounted(() => {
  if (!localStorage.getItem("volunteerData")) {
    getDatatable();
    cash("#static-backdrop-modal-preview-volunteer").modal("show");
  }
});
</script>

<style>
</style>